import CreditCardLoginFlow from '../components/login/CreditCardLoginFlow.svelte';
import LandingPage from '../entry/cardRegularMain.svelte';

const routes = {
    '/': LandingPage,
    '/login': CreditCardLoginFlow,
    '*': LandingPage
};

export default routes;
